"use strict";
exports.isArray = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArray.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/util/isArray.js
 ** module id = 219
 ** module chunks = 0
 **/